import { z } from 'zod';

/**
 * Schema for a single Slack channel
 * Validates the structure of a Slack channel object from the API
 */
export const slackChannelSchema = z.object({
  id: z.string().min(1, 'Channel ID is required'),
  name: z.string().nullable().optional(),
  is_private: z.boolean(),
  is_archived: z.boolean(),
  is_channel: z.boolean(),
  is_group: z.boolean(),
  is_im: z.boolean(),
});

/**
 * Schema for the Slack channels API response
 * Validates the response structure from /api/v1/nango/slack/channels
 */
export const slackChannelsResponseSchema = z.object({
  channels: z.array(slackChannelSchema),
});

/**
 * Type inference from the schema
 */
export type SlackChannel = z.infer<typeof slackChannelSchema>;
export type SlackChannelsResponse = z.infer<typeof slackChannelsResponseSchema>;
